<template>
  <div
    v-if="showContentDeliverer"
    class="container justify-content-center px-0"
  >
    <div class="sticky">
      <h1 v-if="title" class="text-center">ЖУРНАЛ ВЫПЛАТ</h1>
      <router-link
        v-if="false"
        class="btn btn-lg btn-primary w-100 text-center berry"
        type="button"
        tag="button"
        id="payoff-btn"
        :to="{ name: 'payofforder' }"
      >
        Отправить запрос на выплату
      </router-link>
    </div>

    <div class="main-content">
      <div
        v-for="order in payoffOrders"
        :key="order._id"
        class="container pb-2"
      >
        <div class="card lh-1">
          <div class="card-body">
            <div class="row row-cols-2">
              <div class="col text-muted">Дата</div>
              <div class="col text-muted">Статус</div>
              <div class="col pt-1">
                <span class="fs-3">{{
                  new Date(order.createdAt).toLocaleString()
                }}</span>
              </div>
              <div class="col pt-1">
                <span class="badge bg-success text-light fs-4">Выполен</span>
              </div>
            </div>

            <div class="row row-cols-1 pt-2 text-center">
              <div class="col text-muted">Сумма, руб</div>
              <div class="col pt-0">
                <span class="fs-1 lh-1"
                  ><strong>{{ order.amount }}</strong></span
                >
              </div>
            </div>

            <div class="row row-cols-1 pt-2 text-center">
              <div class="col text-muted">Номер карты</div>
              <div class="col pt-0">
                <span class="fs-3 lh-1">{{
                  userCards.find((item) => item.card == order.card).mask
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import useCardsMixin from "@/components/cardsMixin.js";
import useCommonMixin from "@/components/commonMixin.js";

export default {
  name: "PayoffOrders",
  props: {
    title: { default: true },
  },
  components: {},
  setup(props) {
    const store = useStore();
    useCardsMixin();
    useCommonMixin();
    const { showContentDeliverer } = useCommonMixin();
    const { userCards } = useCardsMixin();
    onMounted(store.dispatch("FETCHpayoffOrders"));

    return {
      showContentDeliverer,
      userCards,
      payoffOrders: computed(() => store.getters.payoffOrders),
    };
  },
};
</script>

<style scoped>
</style>

